import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaBlock } from '../CtaBlock';
import { faqs } from '../../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-14 sm:py-20" aria-labelledby="faq-title" data-id="element-118" data-mp="uqj3bbr3yea1">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-119" data-mp="70yj6pj7xaz6">
        <SectionHeading eyebrow="Frequently asked questions" title={<span id="faq-title" data-id="element-121" data-mp="23f4joilyw6p">Your last questions, answered.</span>} data-id="element-120" data-mp="71gmu787mrh4" />

        <ul className="mt-9 space-y-3" data-id="element-122" data-mp="gzo1gjf10xfy">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-navy-100" data-id="element-123" data-mp="c2e5sm11npjo" data-mpi={index}>
                <h3 data-id="element-124" data-mp="1sgnq95260u58">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 bg-navy-50/70 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-navy-100/70" data-id="element-125" data-mp="1nfqcd4o6um9j">
                    <span className="text-[14.5px] font-bold leading-snug text-navy-900 sm:text-base" data-id="element-126" data-mp="rpsprg6h1d4v">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-clinic-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-127" data-mp="3v9x3lithkrle" />
                  </button>
                </h3>
                {isOpen && <div className="bg-white px-4 pb-4 pt-3" data-id="element-128" data-mp="3cie4vo6hvzp6">
                    <p className="text-pretty text-[14px] leading-relaxed text-navy-700 sm:text-[15px]" data-id="element-129" data-mp="3cg1nbc4nfrcn">
                      {faq.answer}
                    </p>
                  </div>}
              </li>;
        })}
        </ul>

        <CtaBlock kicker="No subscriptions. No hidden fees. One payment — and the system is yours." label="👉 I want access now" data-id="element-130" data-mp="ip4on1s1zdaz" />
      </div>
    </section>;
}